import { ApiFunc, getInstance } from '@helpers/httpClient'
import { dissoc, prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const enrollment: ApiFunc<`${typeof API.ENROLLMENT}{id}`, 'get'> = data =>
  instance.get(`${API.ENROLLMENT}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const enrollmentCreate: ApiFunc<`${typeof API.ENROLLMENT}`, 'post'> = data => instance.post(API.ENROLLMENT, data)

export const enrollmentUpdated: ApiFunc<`${typeof API.ENROLLMENT_UPDATED}`, 'post'> = data =>
  instance.post(API.ENROLLMENT_UPDATED, data)

export const enrollmentDelete: ApiFunc<`${typeof API.ENROLLMENT}{id}`, 'delete'> = data =>
  instance.delete(`${API.ENROLLMENT}${'id' in data ? prop('id', data) : data?.name}`)

export const enrollmentList: ApiFunc<`${typeof API.ENROLLMENT}`, 'get'> = data =>
  instance.get(API.ENROLLMENT, {
    params: data,
  })

export const enrollmentAll: ApiFunc<`${typeof API.ENROLLMENT_ALL}`, 'get'> = data =>
  instance.get(API.ENROLLMENT_ALL, {
    params: data,
  })

export const enrollmentStatus: ApiFunc<`${typeof API.ENROLLMENT_STATUS}`, 'put'> = data =>
  instance.put(API.ENROLLMENT_STATUS, data)

export const enrollmentStudentOwn: ApiFunc<`${typeof API.ENROLLMENT_STUDENT_OWN}`, 'get'> = data =>
  instance.get(API.ENROLLMENT_STUDENT_OWN, {
    params: data,
  })

export const enrollmentCourses: ApiFunc<`${typeof API.ENROLLMENT_COURSES}`, 'get'> = data =>
  instance.get(API.ENROLLMENT_COURSES, {
    params: data,
  })
